import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { CapturumTextareaComponent } from '@capturum/ui/textarea';
import { ManageValidatorDisplayDirective } from '@features/client/form-builder/directives/hide-validator.directive';
import { ReactiveFormsModule } from '@angular/forms';
import { FormTooltipComponent } from '@shared/components/form-tooltip/form-tooltip.component';

@Component({
  selector: 'app-textarea-input',
  templateUrl: './textarea-input.component.html',
  imports: [CapturumTextareaComponent, ManageValidatorDisplayDirective, ReactiveFormsModule, FormTooltipComponent],
})
export class TextareaInputComponent extends FieldType {}
